(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  var KEY = 'nyvraCartTimerEnd';
  function endTime(mins) {
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) {}
    if (!end || end <= Date.now()) {
      end = Date.now() + mins * 60000;
      try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    return end;
  }
  function tick() {
    var el = document.querySelector('[data-cart-timer]');
    if (!el) return;
    var mins = parseInt(el.getAttribute('data-minutes'), 10) || 8;
    var left = Math.max(0, endTime(mins) - Date.now());
    var m = Math.floor(left / 60000);
    var s = Math.floor((left % 60000) / 1000);
    var clock = el.querySelector('[data-cart-timer-clock]');
    if (clock) clock.textContent = m + ':' + (s < 10 ? '0' : '') + s;
  }
  tick();
  setInterval(tick, 500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__nyvraReels) return; window.__nyvraReels = true;
  function pauseOthers(current){
    document.querySelectorAll('[data-reel] video').forEach(function(v){ if (v !== current && !v.paused) v.pause(); });
  }
  document.addEventListener('click', function(e){
    var wrap = e.target.closest('[data-reel]'); if (!wrap) return;
    var v = wrap.querySelector('video'); if (!v) return;
    e.preventDefault();
    if (v.paused) { window.__nyvraActive = v; pauseOthers(v); v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function(){ if (window.__nyvraActive === v) { v.muted = true; v.play(); } }); }
    else { if (window.__nyvraActive === v) window.__nyvraActive = null; v.pause(); }
  });
  document.addEventListener('play', function(e){ var w = e.target.closest && e.target.closest('[data-reel]'); if (w) { w.classList.add('is-playing'); pauseOthers(e.target); } }, true);
  ['pause','ended'].forEach(function(ev){
    document.addEventListener(ev, function(e){ var w = e.target.closest && e.target.closest('[data-reel]'); if (w) w.classList.remove('is-playing'); }, true);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
